import { DateBox } from "devextreme-react";
import { Controller, useFormContext, useFormState } from "react-hook-form";
import { DateType } from "devextreme/ui/date_box";

interface IProps {
  title?: string;
  fieldName: string;
  required?: boolean;
  showBorder?: boolean;
  dateType?: DateType;
  disabled?: boolean | undefined;
  defaultValue?: any;
}

export const NFDateInput = ({
  title,
  fieldName,
  required,
  dateType = "datetime",
  showBorder = true,
  disabled = false,
  defaultValue,
}: IProps) => {
  const { control } = useFormContext();
  const { errors, dirtyFields } = useFormState();

  return (
    <Controller
      control={control}
      name={fieldName}
      defaultValue={defaultValue}
      rules={{
        required: required === true,
        onChange: (newValue: string) => {},
      }}
      render={({ field: { onChange, onBlur, value, ref } }) => (
        <div className={`{title ? "form-group" : ""}`}>
          {title && <label className={"form-label-sm"}>{title}</label>}
          <div className="dx-date-box-parent mb-2">
            <DateBox
              type={dateType}
              value={value}
              onValueChanged={(e) => onChange(e.value)}
              style={{ border: showBorder === true ? "block" : "none" }}
              className="bg-light"
              readOnly={disabled === true ? true : undefined}
              validationStatus={
                errors[fieldName]
                  ? "invalid"
                  : dirtyFields[fieldName]
                  ? "valid"
                  : "valid"
              }
            />
          </div>
        </div>
      )}
    />
  );
};
